/* global swal angular */
import './style.less';
import _ from 'lodash';
import { deliveryMethods } from '@prolaera/library';
import { cloneDeep } from 'lodash';

export default function($log, $stateParams, $q, Swal, CategoryClass, ProfileClass, ApiClass) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  vm.selectAllCerts = false;

  vm.select = (select, all = false, cert = false) => {
    if (all) vm.ngModel.certs.forEach(user => (user.selected = select));
    if (cert) cert.selected = true;
    vm.selectedEmployees = vm.ngModel.certs.filter(({ selected }) => selected);
  };

  vm.submit = () => {
    return Swal.confirm('Update Certificates?', 'Selected certificates will be updated')
      .then(() => updateCerts())
      .then(() => Swal.toast('Certificates Updated!'))
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  vm.sync = () => {
    return Swal.confirm('Update Certificates?', 'Selected certificates will be synced with event information.')
      .then(() => updateHours())
      .then(() => Swal.toast('Certificates Updated!'))
      .catch(error => {
        if (error.dismiss) return;
        $log.error(error);
        throw error;
      });
  };

  function updateCert(cert) {
    if (!cert) return;

    cert.delivery_uid = parseInt(cert.delivery_uid);
    cert.selected = false;

    Object.keys(cert.sponsors).forEach(sponsor => {
      if (!cert.sponsors[sponsor] || cert.sponsors[sponsor].length < 1) delete cert.sponsors[sponsor];
    });

    const params = {
      cert: cert.cert,
      cert_id: cert.cert_id,
      date: new Date(cert.date).toISOString(),
      delivery: vm.deliveryDict[cert.delivery_uid].type,
      delivery_uid: cert.delivery_uid,
      hours: cert.hours,
      location: cert.location,
      pdf: cert.pdf,
      profile_uid: cert.profile_uid,
      pdf_uploaded: cert.pdf_uploaded,
      sponsor: cert.sponsors.name,
      sponsors: cert.sponsors || {},
      sponsors_types: cert.sponsors_types || {}
    };

    if (cert.formData && cert.formData.hours_basic) {
      params.hours_basic = cert.formData.hours_basic;
    }

    return ApiClass.usersIdTypeTypeIdPatch(
      { id: cert.profile_uid, type: 'certificates', type_id: cert.cert_id, manage: false },
      params,
      {}
    ).catch(error => {
      $log.error(error);
      throw error;
    });
  }

  function updateCerts() {
    const qArr = vm.selectedEmployees.map(updateCert);
    $q.all(qArr)
      .then(() => {
        Swal.toast('Certificates have been updated!');
        vm.ngModel.certs.forEach(cert => {
          cert.selected = false;
          cert.display = false;
        });
        vm.selectAllCerts = false;
        vm.selectedEmployees = [];
      })
      .catch($log.error);
  }

  function updateHours() {
    vm.selectedEmployees.forEach(user => {
      if (vm.ngModel.course_name) user.cert = cloneDeep(vm.ngModel.course_name);
      if (vm.ngModel.delivery_location) user.location = cloneDeep(vm.ngModel.delivery_location);
      if (vm.ngModel.delivery_date) user.date = cloneDeep(vm.ngModel.delivery_date);
      if (vm.ngModel.hours) user.hours = cloneDeep(vm.ngModel.hours);
      if (vm.ngModel.hours_basic) user.hours_basic = cloneDeep(vm.ngModel.hours_basic);
      if (vm.ngModel.sponsor_types) user.sponsor_types = cloneDeep(vm.ngModel.sponsor_types);
      if (vm.ngModel.sponsors) user.sponsors = cloneDeep(vm.ngModel.sponsors);
      user.formData = user.formData || {};
      user.selected = user.selected || false;
    });
  }

  function activate() {
    $log.debug('Admin Employees Add Hour Component Activated');
    vm.loaded = false;
    vm.error = {};

    vm.deliveryDict = _.keyBy(deliveryMethods, 'key');

    CategoryClass.loadCategories()
      .then(categories => {
        $log.debug('Admin Employees Add Hour Component Data', arguments);
        vm.categories = categories.arr;
        vm.categoryDict = categories.obj;
        vm.deliveryMethods = deliveryMethods;
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/external/certificates/controller.js